import { FC } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@contexts/AuthContext.tsx";
import LoadingFallback from "../common/LoadingFallback";

interface PublicRouteProps {
  children: React.ReactNode;
  allowUnverified?: boolean; // Allow access even if email is not verified
}

const PublicRoute: FC<PublicRouteProps> = ({
  children,
  allowUnverified = false,
}) => {
  const { isAuthenticated, emailVerified, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingFallback message="Checking authentication..." />;
  }

  // If user is authenticated and email is verified, redirect to surveys
  if (isAuthenticated && emailVerified) {
    return <Navigate to="/surveys" replace />;
  }

  // If user is authenticated but email is not verified
  if (isAuthenticated && !emailVerified) {
    // If this route allows unverified users (like verify-email page), show it
    if (allowUnverified) {
      return <>{children}</>;
    }
    // Otherwise redirect to verify email
    return <Navigate to="/verify-email" replace />;
  }

  // User is not authenticated, show the public route
  return <>{children}</>;
};

export default PublicRoute;
